module.exports = __webpack_public_path__ + "Icon-europe.ddb0f9c7751420c234382e1fbcc1f206.svg";